import { render, staticRenderFns } from "./SyetemMenuView.vue?vue&type=template&id=3831718e&scoped=true"
import script from "./SyetemMenuView.vue?vue&type=script&lang=js"
export * from "./SyetemMenuView.vue?vue&type=script&lang=js"
import style0 from "./SyetemMenuView.vue?vue&type=style&index=0&id=3831718e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3831718e",
  null
  
)

export default component.exports